export default __webpack_public_path__ + "0e17d6fcdeea5f20ba49ae441d0ae354.svg";